//==========================================================
// Dictionnaire vee-validate contenant les messages et attributs en français
//
// Permet de : * personnaliser/traduire les noms des champs de formulaire : * personnaliser/traduire les messages d'erreurs custom

//==========================================================


export default {

    // Définition des noms des champs
    // (https://baianat.github.io/vee-validate/guide/messages.html#field-names)
    attributes: {
        // form signup
        signup_organization: "organisation",
        signup_email: "adresse email",
        signup_firstname: "prénom",
        signup_name: "nom",
        signup_password: "mot de passe",
        signup_cgv: "conditions d'utilisations",
        signup_invitation_code: "code d'invitation",
        signupData_org_size: '"taille de l\'organisation"',
        signupData_org_type: '"type de l\'organisation"',
        signupData_position_other: '"rôle"',
        signupData_org_goal: '"objectif"',

        // form login
        login_email: "adresse email",
        login_password: "mot de passe",

        // form pwdReset
        pwdRequest_email: "e-mail",

        // form pwdReset
        pwdReset_password: "mot de passe",
        pwdReset_password_confirm: "confirmation",

        // form userSetting
        userSetting_firstname: "prénom",
        userSetting_name: "nom",
        userSetting_titre: "titre",

        userSetting_email: "e-mail",
        userSetting_orgName: '"nom de l\'organisation"',
        userSetting_preferedTheme: '"thème préféré"',

        userSetting_currentPassword: "mot de passe actuel",
        userSetting_newPassword: "nouveau mot de passe",

        // form trEditModal
        trEditModal_timeIn: '"entrée"',
        trEditModal_timeOut: '"sortie"', //@todo ajouter guillement partout ^

        // form tasktrEditModal
        taskTrEditModal_timeIn: '"entrée"',
        taskTrEditModal_timeOut: '"sortie"',

        // form newTask
        newTask_taskName: '"nom de la tâche"'

        // form project management
        , modalProjectManagement_name: '"nom du projet"'


        // form tag management
        ,modalTagManagement_name : '"nom du tag"'

        // form client management
        , modalClientManagement_name: '"nom du client"'

        // form user management
        , modalUserManagement_name: '"nom de l\'utilisateur"'
        , modalUserManagement_firstname: '"prénom de l\'utilisateur"'
        , modalUserManagement_email: '"e-mail"'
        , modalUserManagement_emailList: '"liste d\'adresses e-mail"'
    }

    // Définition des messages d'erreur personnalisés
    // (https://baianat.github.io/vee-validate/guide/messages.html#field-specific-custom-messages)
    , custom: {
        // form signup
        signup_cgv: {
            required: "Vous devez accepter les conditions d'utilisation"
        },

        userSetting_email: {
            excluded: "L'adresse e-mail est identique"
        },
        // modalProjectManagementComp
        modalProjectManagement_color: {
            required: "Veuillez choisir une couleur"
        },

        // modalTagManagementComp
        modalTagManagement_color: {
            required: "Veuillez choisir une couleur"
        },

    }
    // Définition des messages d'erreurs des validateurs custom
    , custom_validator: {
        signup_invitation_code: "Le code d'invitation n'est pas valide"
        , signup_email_availability: "L'adresse email est déjà utilisée"

        , pwd_request_email_not_found: "L'adresse email est introuvable"
        , userSetting_orgName: "Le nom de l'organisation n'est pas correct"

    }

};
